import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import {
	MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
	MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { UrlService } from '@service/url/url.service';
import { UtilService } from '@service/util/util.service';
import { BaseComponent } from '@shared/base/base.component';
import { RestService } from 'cargo-chief-commons';
import { takeUntil } from 'rxjs';

@Component({
	selector: 'app-confirm-account-dialog',
	templateUrl: './confirm-account-message.component.html',
	encapsulation: ViewEncapsulation.None,
})
export class ConfirmAccountDialogComponent extends BaseComponent implements OnInit {
	isRequestInProgress: boolean = false;

	constructor(
		public dialogRef: MatDialogRef<ConfirmAccountDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public utilService: UtilService,
		private urlService: UrlService,
		private restService: RestService,
		private cargochief: Cargochief
	) {
		super();
	}

	ngOnInit() {}

	sendAccountConfirmationEmail() {
		const url = this.urlService.sendAccountConfirmationEmail(this.cargochief.USER_ID);
		this.isRequestInProgress = true;
		this.restService
			.POST(url, {})
			.pipe(takeUntil(this.isDestroyed$))
			.subscribe({
				next: (result) => {
					this.isRequestInProgress = false;
					this.closeDialog({ emailSent: true });
				},
				error: (error) => {
					this.isRequestInProgress = false;
					this.closeDialog({ emailSendingFailed: true, emailFailedError: error.error });
				},
			});
	}

	closeDialog(result = {}): void {
		this.dialogRef.close(result);
	}

	ngOnDestroy(): void {
		super.ngOnDestroy();
	}
}
